import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
//@ts-ignore cortex
///@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
import {
    IconTextButton,
    Button,
    Loading,
    Table,
    Pagination,
    Modal,
    Image,
    //@ts-ignore cortex
} from "@cortexglobal/rla-components";

import { EmptyRow } from "../../../components/EmptyRow";
import { EventCategory } from "../../../forms/EventCategoryForm";

const PaddedDiv = styled.div`
    padding: 3em;
`;

const TableHeader = styled.div`
    cursor: pointer;
    display: inline-block;

    &:hover {
        text-decoration: underline;
    }
`;

export const EventCategoryTable = ({
    items,
    loaded,
    path,
    pagination = null,
    deleteItem,
    onPageChange,
    onOrderBy,
    onPerPageChange,
}: EventCategoryTableProps) => {
    const currentPage = pagination ? pagination.current_page : 1;

    const [
        deleteEventCategoryModalShowing,
        setDeleteEventCategoryModalShowing,
    ] = useState(false);
    const [deleteEventCategoryName, setDeleteEventCategoryName] = useState("");
    const [deleteEventCategoryId, setDeleteEventCategoryId] = useState(null);

    return (
        <React.Fragment>
            <Table>
                <thead>
                    <tr>
                        <th>{trans("Name")}</th>
                        <th>{trans("Description")}</th>
                        <th>{trans("Thumbnail")}</th>
                        {/* <th>
                            <TableHeader onClick={() => onOrderBy("alias")}>
                                {trans("Alias")}
                            </TableHeader>
                        </th> */}
                        <th>{trans("Actions")}</th>
                    </tr>
                </thead>
                <tbody>
                    {!loaded ? (
                        <EmptyRow colSpan={3}>
                            <Loading />
                        </EmptyRow>
                    ) : !items || items.length === 0 ? (
                        <EmptyRow colSpan={3}>
                            {trans("No items found")}
                        </EmptyRow>
                    ) : (
                        items.map((item) => {
                            return (
                                <tr>
                                    <td>{item.name}</td>
                                    <td>{item.description}</td>
                                    <td>
                                        {item.thumbnail ? (
                                            <Image
                                                style={{
                                                    maxWidth: "100%",
                                                    maxHeight: "60px",
                                                }}
                                                src={item.thumbnail}
                                            />
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                    <td>
                                        <IconTextButton
                                            as={Link}
                                            to={`${path}/edit/${item.uuid}?page=${currentPage}`}
                                            showCircle={false}
                                            expanded={false}
                                            icon={faEdit}
                                        >
                                            {trans("Edit")}
                                        </IconTextButton>
                                        <IconTextButton
                                            type="alert"
                                            showCircle={false}
                                            expanded={false}
                                            icon={faTrash}
                                            onClick={(event) => {
                                                setDeleteEventCategoryId(
                                                    item.uuid
                                                );
                                                setDeleteEventCategoryModalShowing(
                                                    true
                                                );
                                                setDeleteEventCategoryName(
                                                    item.name
                                                );
                                            }}
                                        >
                                            {trans("Delete")}
                                        </IconTextButton>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </Table>
            {pagination && (
                <Pagination
                    onPerPageChange={onPerPageChange}
                    style={{ clear: "both" }}
                    currentPage={pagination.current_page - 1}
                    perPage={pagination.per_page}
                    pageCount={pagination.last_page}
                    onPageChange={({ selected }) => onPageChange(selected + 1)}
                    {...pagination}
                />
            )}
            {deleteEventCategoryModalShowing && (
                <Modal
                    visible={deleteEventCategoryModalShowing}
                    onClose={() => {
                        setDeleteEventCategoryModalShowing(false);
                    }}
                >
                    <PaddedDiv>
                        <h1>
                            {trans("You are about delete event category")}:
                            {deleteEventCategoryName}
                        </h1>

                        <p>{trans("Are you sure you want to proceed?")}</p>
                        <Button
                            type="hollow"
                            style={{ marginRight: "1em" }}
                            onClick={() => {
                                setDeleteEventCategoryModalShowing(false);
                            }}
                        >
                            {trans("Cancel")}
                        </Button>
                        <Button
                            type="alert"
                            onClick={() => {
                                deleteItem(deleteEventCategoryId)
                                    .then((data) => {
                                        setDeleteEventCategoryModalShowing(
                                            false
                                        );
                                    })
                                    .catch((e) =>
                                        setDeleteEventCategoryModalShowing(
                                            false
                                        )
                                    );
                            }}
                        >
                            {trans("Delete")}
                        </Button>
                    </PaddedDiv>
                </Modal>
            )}
        </React.Fragment>
    );
};

interface EventCategoryTableProps {
    items: EventCategory[];
    loaded: boolean;
    path: string;
    pagination?: any;
    deleteItem: (number) => Promise<void>;
    onPageChange?: (number) => void;
    onOrderBy?: (string) => void;
    onPerPageChange?: (any) => void;
}

export default EventCategoryTable;
